module.exports = __webpack_public_path__ + "static/media/loyalty-asset.2fa5a848.svg";